import React, { useState } from "react";
import { colors } from "../../../../../../themes/Colors";
import { BaseButtons } from "../../../../../common-components";

const BuzzListItem = ({
  category,
  subCategory,
  description,
  sentBy,
  dateRequested,
  status,
  onViewClick,
}) => {
  return (
    <div
      style={{
        width: "100%",
        minHeight: 40,
        paddintop: 5,
        // paddingBottom: 5,
        backgroundColor: colors.white,
        display: "flex",
        alignItems: "center",
        borderBottomStyle: "solid",
        borderBottomWidth: 1,
        borderColor: "#00000030",
      }}
    >
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
        }}
      >
        <div style={{ marginLeft: 10 }}> {category}</div>
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
        }}
      >
        {subCategory}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
          overflow: "hidden",
        }}
      >
        <div style={{ width: "85%", overflow: "hidden" }}>{description}</div>
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.2,
        }}
      >
        {sentBy}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.15,
        }}
      >
        {dateRequested}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.1,
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
        }}
      >
        {status}
      </div>
      <div
        style={{
          fontWeight: "bold",
          fontSize: 10,
          //   color: colors.white,
          flex: 0.15,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"VIEW"}
          borderRadius={4}
          backgroundColor={colors.greenLight}
          height={30}
          width={"95%"}
          onClick={onViewClick}
        />
      </div>
    </div>
  );
};

export default BuzzListItem;
